import React from 'react';
import avatar from '../assets/gia_avatar.webp';
import bust from '../assets/gia_bust.webp';
import portrait from '../assets/gia_portrait.webp';
import full from '../assets/gia_full.webp';
import './gia.css';

/** QIRA, the AI agent of the system: one set of pictures, used wherever she appears. */
export const QIRA = { avatar, bust, portrait, full };

/** her face in a round badge (chat bubbles, menu, floating button) */
export function GiaAvatar({ size = 32, online = false, className = '', style }) {
  return (
    <span className={`gia-av ${online ? 'online' : ''} ${className}`} style={{ width: size, height: size, ...style }}>
      <img src={avatar} alt="QIRA" width={size} height={size} draggable={false} />
    </span>
  );
}
/** the navigation icon of QIRA (same size as the other icons of the menu) */
export const GiaNavIcon = () => <GiaAvatar size={24} />;
